import { NaploService } from './naplo.service';

/*  STORNO SZÁMLA ÉS AZ EREDETIJE – a két könyvelőablak (egyszeres, kettős) közös keresője.
 *
 *  A NAV-ból (OSA) jövő storno számla az eredetire hivatkozik (`eredeti_szamlaszam`, `muvelet`
 *  = STORNO). Két eset van:
 *   – az eredeti MÁR le van könyvelve: a storno egy kattintással a tükre lesz (0 egyenleg);
 *   – az eredeti MÉG NINCS: a kettő együtt könyvelhető – az eredeti nyílik a könyvelőablakban,
 *     és a mentésekor a storno is lekönyvelődik.
 *  Mindkét irányból (az eredeti vagy a storno „Könyvelés" gombjáról) ugyanide jutunk. */
export const stornoE = (s: any) => String(s?.muvelet || '').toUpperCase() === 'STORNO' && !!s?.eredeti_szamlaszam;

async function tarolt(naplo: NaploService, ugyfelId: string, irany: string): Promise<any[]> {
  const dir = irany === 'outbound' || irany === 'bevetel' ? 'outbound' : 'inbound';
  try { return ((await naplo.get<any>(`/osa/cache/${ugyfelId}?direction=${dir}`))?.szamlak) || []; } catch { return []; }
}

/** Az eredeti számlára hivatkozó, még könyveletlen storno (ha van). */
export async function stornoParKeres(naplo: NaploService, ugyfelId: string, sz: any, konyvelt: (s: any) => boolean): Promise<any | null> {
  if (!sz?.szamlaszam || stornoE(sz)) return null;
  const l = await tarolt(naplo, ugyfelId, sz.irany);
  return l.find((x) => stornoE(x) && x.eredeti_szamlaszam === sz.szamlaszam && !konyvelt(x)) || null;
}

/** A storno eredetije a tárolt OSA-listából (ha le van töltve). */
export async function eredetiKeres(naplo: NaploService, ugyfelId: string, storno: any): Promise<any | null> {
  const l = await tarolt(naplo, ugyfelId, storno.irany);
  return l.find((x) => x.szamlaszam === storno.eredeti_szamlaszam) || null;
}
